<template>
<div class="main">
    <div class="loginInfo">
        <div class="logo">
            <img :src="configuration.loginLogo" alt="">
            <div class="text">{{configuration.projectName}}</div>
            <div class="version">{{pages_version}}</div>
        </div>

        <form @submit.prevent="login">
            <!-- <div class="myTab" :class="{'mb':isCode}">
                <div class="code" :class="{active:isCode}" @click="isCode=!isCode">扫码登录</div>
                <div class="account" :class="{active:!isCode}" @click="isCode=!isCode">账号登录</div>
            </div>
            <div class="qrCode logo_info" v-show="isCode" style="height:200px;">
                <div id="myContainer" style="height:200px;" :class="{'pQrcode':isCode}"></div>
            </div> -->
            <div class="logo_info" v-show="!isCode">
                <div class="inputStyle">
                    <img src="../../assets/images/pics/log_right_icon_account.png" alt="">
                    <input type="text" placeholder="用户名" v-model.trim="model.username" required>
                </div>
                <div class="inputStyle">
                    <img src="../../assets/images/pics/log_right_icon_password.png" alt="">
                    <input type="password" placeholder="密码" v-if="!eyeImg" v-model.trim="model.password" required>
                    <input type="text" placeholder="密码" v-else v-model.trim="model.password" required>
                    <img :src='[eyeImg?visibleImg:unVisibleImg]' alt="" @click="eyeImg=!eyeImg">
                </div>
                <div class="codeZone">
                    <div class="inputStyle_new">
                        <img src="../../assets/images/pics/log_right_icon_code.png" alt="">
                        <input type="text" placeholder="验证码" v-model.trim="model.validateCode" required>
                    </div>
                    <div class="testCode">
                        <img @click="getVerifyCode" :src="imgSrc" alt="">
                    </div>
                </div>
                <button class="submit_btn" ref="loginBtn" type="submit">账号登录</button>
                <!-- <button class="submit_btn mt20" ref="loginBtnFace" type="button" @click="faceLogin">人脸登录</button> -->
            </div>
            <div style="margin-top:30px;">
                <a style="color:#c2c7cf;" href="https://beian.miit.gov.cn" target="_blank">京ICP备2024091663号-2</a>
            </div>
        </form>
    </div>
    <transition name="el-zoom-in-center">
        <camera :tackPhoto="tackPhoto" v-if="tackPhoto" @closeCamera="closeCamera" :faceSet="faceSet"></camera>
    </transition>
    <transition name="el-zoom-in-center">
        <send v-if="sendShow" :openId="openId" @hideSend="hideSend"></send>
    </transition>
</div>
</template>

<script>
import TRTC from 'trtc-js-sdk'
import config from '@/common/env.js'
import Cookies from 'js-cookie'
import Fingerprint2 from 'fingerprintjs2'
import camera from '@/components/camera.vue'
import send from './sendMessage.vue'
export default {
    data() {
        let time = Math.random();
        return {
            sendShow: false,
            openId: '',
            state: '',
            isCode: false,
            faceSet: false,
            tackPhoto: false,
            model: {
                "username": null,
                "password": null,
                "fingerPrint": null,
                "validateCode": null
            },
            inputFlag: '0',
            rememberPassword: false,
            imgSrc: `${config.baseUrl}/user/getVerifyCode?t=${time}`,
            eyeImg: false,
            visibleImg: require('../../assets/images/pics/log_right_icon_visible_sel.png'),
            unVisibleImg: require('../../assets/images/pics/log_right_icon_invisible_sel.png'),
            pages_version: config.pages_version
        }
    },

    components: {
        camera,
        send
    },
    created() {

    },
    mounted() {
        let that = this;
        // this.setWxerwma();
        this.onTest()
        this.smRe();
        // this.getVerifyCode();
        // // this.fetchAdminUserInfo();
        // let userInfo = localStorage.getItem("userInfo");
        // if (userInfo) {
        //   userInfo = JSON.parse(userInfo);
        //   this.rememberPassword = true;
        //   this.userInfo.userName = userInfo.username;
        //   this.userInfo.password = userInfo.password;
        // }
        this.getFingerPrint();
        // const oScript = document.createElement('script');
        // oScript.type = 'text/javascript';
        // oScript.src = 'http://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js';
        // document.body.appendChild(oScript);
        // setTimeout(() => {
        //     that.state = Math.ceil(Math.random() * 1000)
        //     const obj = new WxLogin({
        //         self_redirect: false,
        //         id: 'myContainer', // 需要显示的容器id
        //         appid: 'wx6dd49f3e381f609c', // 公众号appid wx*******
        //         scope: 'snsapi_login', // 网页默认即可
        //         redirect_uri: encodeURIComponent('https://qd.024syjj.net/auth/login'), // 授权成功后回调的
        //         state: that.state, // 可设置为简单的随机数加session用来校验
        //         style: 'black', // 提供"black"、"white"可选。二维码的样式
        //         href: 'https://qd.024syjj.net/static/css/wxCode.css' // 外部css文件url，需要https
        //     })
        // }, 500)
    },
    watch: {
        $route: {
            handler: function (route) {
                let _this = this;
                this.wxCode = this.$route.query.code || ''
                //本地存储code是因为从其他页面返回vue页面存在缓存需要自定义刷新
                if (this.wxCode == localStorage["wxCode"] && this.wxCode != '') {
                    // window.location.href = this.redirect_uri //回调地址
                } else {
                    localStorage.setItem("wxCode", this.wxCode); //设置b为"isaac"
                }
                if (this.wxCode) {
                    let params = {
                        code: this.wxCode,
                        state: '',
                    }
                    this.wechatLogin(this.wxCode).then(res => {
                        console.log('啥玩意wechatLogin', res)
                        let data = res.data.data;
                        if (res.data.code == 0) {
                            if (data.bindPhone == 0) {
                                this.openId = data.openId;
                                this.sendShow = true;
                            } else if (data.bindPhone == 1) {
                                console.log('啥玩意跳转前', data)
                                var infos = data.userInfo;
                                _this.$store.commit("TOKEN_INIT", {
                                    token: infos.token
                                });
                                localStorage.setItem('userinfos', JSON.stringify(infos));
                                if (infos.token) {
                                    localStorage.setItem('token', infos.token)
                                    this.AppUtils.setCookie("token", infos.token);
                                    _this.$store.commit("ONLINE_STATUS", infos.onlineStatus);
                                }
                                let menus = infos.userRoles;
                                if (menus && menus.length == 1 && menus[0].roleId == 40) {
                                    this.$router.push('/workPlat120');
                                    return false;
                                }
                                this.$message.success('微信扫码登录成功');
                                this.$router.push('/workPlat');
                            }
                            //返回参数如果绑定微信返回token正常存储登录未绑定账号返回unionid绑定当然也可以以微信信息为主题自动生成账号
                        }
                    }).catch(() => {
                        //返回失败因为二维码已经被使用过所以需要刷新重新获取
                        window.location.href = this.redirect_uri
                    });
                }
            },
            immediate: true
        },
        'model.validateCode': { // 深度监听，可监听到对象、数组的变化
            handler(val, oldVal) {
                if (val) {
                    if (val.length > 4) {
                        this.$message.error('验证码位数是4位');
                        var value = val.toUpperCase();
                        this.model.validateCode = value.slice(0, 4)
                    } else {
                        this.model.validateCode = val.toUpperCase();
                    }
                }
            },
            deep: true
        }
    },
    methods: {
        hideSend() {
            this.sendShow = false;
        },
        wechatLogin(code) {
            var _this = this;
            return new Promise((resolve, reject) => {
                _this.$axios.get(`/user/checkWeChatLogin/${code}`).then(res => {
                    console.log('res', res)
                    resolve(res)
                }).catch(err => {

                });
            })
        },
        setWxerwma() {
            const obj = new WxLogin({
                self_redirect: false,
                id: 'login_container', // 需要显示的容器id
                appid: 'wx6dd49f3e381f609c', // 公众号appid wx*******
                scope: 'snsapi_login', // 网页默认即可
                redirect_uri: encodeURIComponent('https://passport.zcool.com.cn/thirdlogin/wechat_callback.do?appId=1006'), // 授权成功后回调的
                state: Math.ceil(Math.random() * 1000), // 可设置为简单的随机数加session用来校验
                style: 'black', // 提供"black"、"white"可选。二维码的样式
                href: 'https://static.zcool.cn/passport4.0/css/wxCode.css?v=0.1' // 外部css文件url，需要https
            })
        },
        onTest() {
            TRTC.checkSystemRequirements().then((result) => {
                console.log(result)
                if (!result) {
                    // SDK 不支持当前浏览器，建议用户使用最新版本的 Chrome 浏览器。
                    this.$message({
                        message: 'SDK 不支持当前浏览器，建议使用最新版本的 Chrome 浏览器',
                        type: 'warning'
                    })
                }
            })
        },
        closeCamera() {
            this.tackPhoto = false;
        },
        faceLogin() {
            this.tackPhoto = true;
        },
        getFingerPrint() {
            var _this = this;
            Fingerprint2.get(function (components) {
                const values = components.map(function (component, index) {
                    if (index === 0) { //把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不一样
                        return component.value.replace(/\bNetType\/\w+\b/, '')
                    }
                    return component.value
                })
                // 生成最终id murmur
                const murmur = Fingerprint2.x64hash128(values.join(''), 31);
                _this.model.fingerPrint = murmur;
            })
        },
        smRe() {
            let t = new Date().getTime();
            this.$axios.get('/sm?t=' + t).then(res => {})
        },
        login() {
            let _loginBtn = this.$refs.loginBtn;
            _loginBtn.disabled = true;
            // _loginBtn.innerText = "登录中..."
            var _this = this;
            this.$axios.post('/user/login', this.model).then(res => {
                console.log('res', res)
                if (res.data.code == 0) {
                    var infos = res.data.data;
                    _this.$store.commit("TOKEN_INIT", {
                        token: infos.token
                    });
                    localStorage.setItem('imId',infos.imUserId);
                    localStorage.setItem('userinfos', JSON.stringify(infos));
                    if (infos.token) {
                        localStorage.setItem('token', infos.token)
                        this.AppUtils.setCookie("token", infos.token);
                        _this.$store.commit("ONLINE_STATUS", infos.onlineStatus);
                    }
                    let menus = infos.userRoles;
                    if (menus && menus.length == 1 && menus[0].roleId == 40) {
                        this.$router.push('/workPlat120');
                        return false;
                    }
                    /* if(menus && menus.length > 0) {
                      let router = menus[0].menuList[0].path;
                      this.$router.push(router);
                    } else
                    if(infos.activeSeat){
                      this.$router.push('/workPlat');
                    }else{
                      this.$router.push('/hall');
                    }*/
                    this.$router.push('/workPlat');
                    // this.goWorkPlat();
                } else {
                    this.$message.error(res.data.msg);
                    _loginBtn.disabled = false;
                    _loginBtn.innerText = "登录"
                    this.getVerifyCode()
                }
            }).catch(err => {
                _loginBtn.disabled = false;
                // _loginBtn.innerText = "登录"
                this.getVerifyCode()
            });
        },
        goWorkPlat() {
            window.open('/workPlat', '_self', this.getWindowName('workPlat')).focus();
        },
        getWindowName(role) {
            return `${location.origin}-${role}`;
        },
        getVerifyCode() {
            let time = Math.random();
            this.imgSrc = this.CODE_SERVER + '/user/getVerifyCode?t=' + time;
        }
    }
}
</script>

<style lang="scss" scoped>
.myTab {
    height: 25px;
    display: flex;
    justify-content: center;
    font-size: 15px;
    margin-bottom: 10px;

    .active {
        color: #17294c;
        font-weight: bold;
    }

    .code {
        box-sizing: border-box;
        height: 25px;
        line-height: 25px;
        padding-right: 20px;
        border-right: 1px solid #ccc;
        margin-right: 20px;
        cursor: pointer;
    }

    .account {
        height: 25px;
        line-height: 25px;
        cursor: pointer;
    }
}

.main {
    width: 100%;
    height: 100%;
    background: url('../../assets/images/pics/log_bg_new.png') no-repeat center center;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;

    .loginInfo {
        // width: 707px;
        height: 375px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-direction: row;

        .logo {
            width: 260px;
            height: 375px;
            background: url("../../../static/images/commons/log_left_bg.png") no-repeat center center;
            background-size: 100% 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-direction: column;
            box-sizing: border-box;
            padding-top: 50px;

            img {
                display: block;
                width: 67px;
                height: 67px;
            }

            .text {
                height: 33px;
                text-align: center;
                opacity: 1;
                font-size: 16px;
                font-family: PingFangSC, PingFangSC-Medium;
                font-weight: 500;
                text-align: justify;
                color: #ffffff;
                line-height: 33px;
                margin-top: 20px;
            }
        }

        .logo_info {
            width: 475px;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;

            .inputStyle {
                width: 250px;
                height: 40px;
                // opacity: 0.3;
                // border: 1px solid #073e90;
                border: 1px solid rgba(7, 62, 144, 0.3);
                border-radius: 4px;
                margin-bottom: 20px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                flex-direction: row;
                box-sizing: border-box;
                padding: 10px;

                // background: #F7F7F9;
                img {
                    width: 20px;
                    height: 20px;
                    display: inline;
                    margin-right: 7px;
                    cursor: pointer;
                }

                input {
                    display: inline;
                    width: 200px;
                    height: 30px;
                    line-height: 30px;
                    border: none;
                }
            }

            .codeZone {
                width: 250px;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 20px;

                .inputStyle_new {
                    width: 140px;
                    height: 40px;
                    // opacity: 0.3;
                    // border: 1px solid #073e90;
                    border: 1px solid rgba(7, 62, 144, 0.3);
                    border-radius: 4px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    flex-direction: row;
                    box-sizing: border-box;
                    padding: 10px;

                    // background: #F7F7F9;
                    img {
                        width: 20px;
                        height: 20px;
                        display: inline;
                        margin-right: 7px;
                        cursor: pointer;
                    }

                    input {
                        display: inline;
                        width: 100px;
                        height: 30px;
                        line-height: 30px;
                        border: none;
                    }
                }

                .testCode {
                    width: 100px;
                    height: 40px;

                    /*background: red;*/
                    img {
                        display: block;
                        width: 100%;
                        height: 100%;
                    }
                }
            }

            .submit_btn {
                width: 250px;
                height: 40px;
                text-align: center;
                line-height: 40px;
                border: 1px solid #073e90;
                background: #17294c;
                border-radius: 4px;
                font-size: 16px;
                font-family: PingFangSC, PingFangSC-Medium;
                font-weight: 500;
                color: #fff;
                cursor: pointer;
            }
        }
    }
}

.version {
    color: #fff;
    margin-top: 130px;
}
.mb{
    margin-bottom: 90px;
}
.pQrcode{
    position: relative;
    top: -66px;
}
</style>



// WEBPACK FOOTER //
// login.vue?2d1061c0